import { useEffect, useRef } from "react";

const EmbedWistia = ({ videoCode }) => {
   const wistiaSwatch = useRef(null);

   useEffect(() => {
      const script1 = document.createElement("script");
      const script2 = document.createElement("script");

      script1.src = `https://fast.wistia.com/embed/medias/${videoCode}.jsonp`;
      script1.id = `${videoCode}-script1`;
      script1.async = true;

      script2.src = `https://fast.wistia.com/assets/external/E-v1.js`;
      script2.id = `${videoCode}-script2`;
      script2.async = true;

      if (!document.querySelector(`#${script1.id}`)) {
         document.body.appendChild(script1);
      }
      if (!document.querySelector(`#${script2.id}`)) {
         document.body.appendChild(script2);
      }
      return () => {
         document.querySelector(`#${script1.id}`).remove();
         document.querySelector(`#${script2.id}`).remove();
      };
   }, [videoCode]);

   return (
      <div className="video-container">
         <div
            className="wistia_responsive_padding"
            style={{ padding: "56.25% 0 0 0", position: "relative" }}
         >
            <div
               className="wistia_responsive_wrapper"
               style={{
                  height: "100%",
                  left: 0,
                  position: "absolute",
                  top: 0,
                  width: "100%",
               }}
            >
               <div
                  className={`wistia_embed wistia_async_${videoCode} videoFoam=true`}
                  style={{
                     height: "100%",
                     position: "relative",
                     width: "100%",
                  }}
               >
                  <div
                     className="wistia_swatch"
                     ref={wistiaSwatch}
                     style={{
                        height: "100%",
                        left: 0,
                        opacity: 0,
                        overflow: "hidden",
                        position: "absolute",
                        top: 0,
                        transition: "opacity 200ms",
                        width: "100%",
                     }}
                  >
                     <img
                        src={`https://fast.wistia.com/embed/medias/${videoCode}/swatch`}
                        style={{
                           filter: "blur(5px)",
                           height: "100%",
                           objectFit: "contain",
                           width: "100%",
                        }}
                        alt=""
                        aria-hidden="true"
                        onLoad={() => {
                           wistiaSwatch.current.style.opacity = 1;
                        }}
                     />
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

const EmbedVideo = ({ videoCode, embedType }) => {
   return embedType === "wistia" ? <EmbedWistia videoCode={videoCode} /> : "";
};

export default EmbedVideo;
